import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

// Importing CSS for styling
import "./header.css";

// Define the Header component
const Header = () => {
  // Local State
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // function to toggle menu
  const toggleMenu = () => { setIsMenuOpen(!isMenuOpen); };

  return (
    <header>
      {/* Top bar section with contact info */}
      <div className="header-top-bar">
        <div className="container">
          <div className="row align-items-center">
            {/* Left section of top bar - contact info */}
            <div className="col-lg-6 d-none d-lg-block">
              <ul className="top-bar-info list-inline-item pl-0 mb-0">
                {/* Email */}
                <li className="list-inline-item">
                  <a href="mailto:support@gmail.com">
                    <i className="icofont-support-faq mr-2"></i>bhoomirockproducts@gmail.com
                  </a>
                </li>
              </ul>
            </div>

            {/* Right section of top bar - phone number */}
            <div className="col-lg-6 text-center">
              <div className="text-lg-right top-right-bar mt-2 mt-lg-0">
                <a href="tel:+23-345-67890">
                  <span>Call Now : </span>
                  <span className="h4">+91 97407 36636</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation bar */}
      <nav className="navbar navbar-expand-lg navigation" id="navbar">
        <div className="container">
          {/* Logo section */}
          <Link className="navbar-brand" to="/" style={{width: '250px'}}>
            <img src="images/logo.png" alt="" className="img-fluid" />
          </Link>

          {/* Hamburger menu toggle for mobile devices */}
          <button
            className="navbar-toggler collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#navbarmain"
            aria-controls="navbarmain"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{ color: 'maroon' }}
            onClick={toggleMenu}
          >
            <span className="icofont-navigation-menu"></span>
          </button>

          {/* Collapsible navigation links */}
          <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`} id="navbarmain">
            <ul className="navbar-nav ml-auto">
              {/* Home link */}
              <li className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
                <Link className="nav-link" to="/" onClick={toggleMenu}>Home</Link>
              </li>

              {/* About link */}
              <li className={`nav-item ${location.pathname === '/about' ? 'active' : ''}`}>
                <Link className="nav-link" to="/about" onClick={toggleMenu}>About</Link>
              </li>

              {/* Product link */}
              <li className={`nav-item ${location.pathname === '/product' ? 'active' : ''}`}>
                <Link className="nav-link" to="/product" onClick={toggleMenu}>Product</Link>
              </li>

              {/* Contact link */}
              <li className={`nav-item ${location.pathname === '/contact' ? 'active' : ''}`}>
                <Link className="nav-link" to="/contact" onClick={toggleMenu}>Contact</Link>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};


export default Header;
